import React from "react";
import { motion } from "framer-motion";
import { WhatsAppIcon } from "./icons";
import { COMPANY } from "../data/site";

export const WhatsAppButton = () => (
  <motion.a
    href={`https://wa.me/${COMPANY.whatsapp}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-launcher"
    aria-label="Chat with us on WhatsApp"
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-24 right-5 z-[55] w-16 h-16 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center"
  >
    <WhatsAppIcon className="w-8 h-8" />
    <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white/90 border-2 border-[#25D366] animate-pulse" />
  </motion.a>
);
